<template>
  <div class="supplier-configure">
    <div class="supplier-configure-main">
      <div class="title">授权配置</div>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{scope.$index+1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="公司名称"></el-table-column>
          <el-table-column prop="head" label="负责人"></el-table-column>
          <el-table-column prop="telephone" label="手机号"></el-table-column>
          <el-table-column prop="statusVal" label="状态">
            <template slot-scope="scope">
              <div :class="statusClassName[scope.row.status]">
                <i class="el-icon-warning"></i>
                <span class="status-name">{{scope.row.statusVal}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                class="btn-text"
                type="text"
                v-if="scope.row.status===0"
                @click="supplierCheck(scope.row.id,0)"
              >审核</el-button>
              <el-button
                class="btn-text"
                type="text"
                v-if="scope.row.status===2"
                @click="supplierCheck(scope.row.id,2)"
              >启用</el-button>
              <el-button
                class="btn-text"
                type="text"
                v-if="scope.row.status===1"
                @click="supplierCheck(scope.row.id,1)"
              >禁用</el-button>
              <el-button
                class="btn-text"
                type="text"
                @click="permissionSetting(scope.row)"
              >权限设置</el-button>
              <el-button
                class="btn-red"
                type="text"
                @click="delSupplier(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="权限设置" :visible.sync="dialogVisible" width="400px" top="25vh" :before-close="handleClose">
      <div class="row">
        <div class="title">库存编辑：</div>
        <el-radio-group v-model="stock">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </div>
      <div class="row">
        <div class="title">商品入库：</div>
        <el-radio-group v-model="goodsWarehousing">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </div>
      <div class="row">
        <div class="title">商品修改权限：</div>
        <el-radio-group v-model="goodsModify">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </div>
      <div class="row">
        <div class="title">商品修改复核：</div>
        <el-radio-group v-model="goodsReview">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </div>
      <div class="row">
        <div class="title">商品删除：</div>
        <el-radio-group v-model="goodsDel">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </div>
      <div class="row">
        <div class="title">商品下架：</div>
        <el-radio-group v-model="goodsDown">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="handleClose">取 消</el-button>
        <el-button class="btn-blue" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Apply from "models/db/apply";
const apply = new Apply();
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      supplierId: null,
      stock: 1,
      goodsWarehousing: 1,
      goodsModify: 0,
      goodsReview: 0,
      goodsDel: 0,
      goodsDown: 1,
      statusClassName: {
        0: 'blue-status',
        1: 'green-status',
        2: 'red-status'
      }
    };
  },
  created() {
    this.$emit("childMueu", "供应商授权", "授权配置", '/admin/apply/supplier-introduce');
    this.getTableData();
  },
  methods: {
    getTableData() {
      apply.getSupplierList().then((res) => {
        if (res.success) {
          let tableData = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.supplierId = value.supplierId;
            obj.username = value.username;
            obj.head = value.head;
            obj.telephone = value.telephone;
            obj.status = value.status;
            obj.goodsModify = value.goodsModify;
            obj.goodsReview = value.goodsReview;
            obj.goodsDel = value.goodsDel;
            obj.goodsDown = value.goodsDown;
            obj.storageModify = value.storageModify;
            obj.storageIn = value.storageIn;
            obj.statusVal =
              value.status === 0
                ? "待审核"
                : value.status === 1
                ? "已通过"
                : "已拒绝";
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },
    supplierCheck(id, type) {
      if (type === 0) {
        this.$confirm("是否通过该供应商申请？", "审核", {
          distinguishCancelAndClose: true,
          confirmButtonText: "通过",
          cancelButtonText: "拒绝",
          type: "warning",
        })
          .then(() => {
            let data = {};
            data.id = id;
            data.isPass = 1;
            apply.postSupplierCheck(data).then((res) => {
              if (res.success) {
                this.getTableData();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch((action) => {
            if (action === "cancel") {
              let data = {};
              data.id = id;
              data.isPass = 0;
              apply.postSupplierCheck(data).then((res) => {
                if (res.success) {
                  this.getTableData();
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          });
      } else if (type === 1) {
        this.$confirm("是否禁用该供应商？", "禁用", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = {};
          data.id = id;
          apply.postSupplierUpdateStatus(data).then((res) => {
            if (res.success) {
              this.getTableData();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      } else if (type === 2) {
        this.$confirm("是否启用该供应商？", "启用", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = {};
          data.id = id;
          apply.postSupplierUpdateStatus(data).then((res) => {
            if (res.success) {
              this.getTableData();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      }
    },
    permissionSetting(row) {
      this.supplierId = row.id
      this.stock = row.storageModify
      this.goodsWarehousing = row.storageIn
      this.goodsModify = row.goodsModify
      this.goodsReview = row.goodsReview
      this.goodsDel = row.goodsDel
      this.goodsDown = row.goodsDown
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    confirm() {
      let userId = this.supplierId
      let storageModify = this.stock
      let storageIn = this.goodsWarehousing
      let goodsModify = this.goodsModify
      let goodsReview = this.goodsReview
      let goodsDel = this.goodsDel
      let goodsDown = this.goodsDown
      let data = {
        userId,
        storageModify,
        storageIn,
        goodsModify,
        goodsReview,
        goodsDel,
        goodsDown,
      }
      apply.postModifySupplierAuthority(data).then(res => {
        if (res.success) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getTableData();
          this.handleClose()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    delSupplier(row) {
      this.$confirm("删除后无法恢复，是否确认删除？", "删除", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-white",
      }).then(() => {
        let supplierId = row.supplierId
        let data = {
          supplierId,
        };
        apply.postDelSupplierAuthority(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getTableData();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.supplier-configure {
  padding: 16px;
  flex: 1;
  overflow: auto;
  .supplier-configure-main {
    background: #fff;
    min-height: 100%;
    padding: 16px;
    box-sizing: border-box;
    border-radius: 4px;
    .title {
      height: 32px;
      background: rgba(245, 247, 250, 1);
      border-radius: 8px 8px 0px 0px;
      padding-left: 6px;
      font-size: 16px;
      line-height: 32px;
      margin-bottom: 20px;
    }
  }
  .row {
    display: flex;
    justify-content: center;
    .title {
      width: 100px;
      text-align: right;
      margin-bottom: 12px;
    }
  }
  .green-status,
  .blue-status,
  .red-status {
    width: 66px;
    height: 22px;
    padding: 5px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    .el-icon-warning {
      font-size: 14px;
      margin-right: 4px;
    }
    .status-name {
      display: inline-block;
      height: 12px;
      line-height: 11px;
      font-size: 12px;
      font-weight: 400;
    }
  }
  .blue-status {
    background: rgba(46, 104, 234, 0.14);
    color: #2E68EA;
    .el-icon-warning {
      color: #2E68EA;
    }
  }
  .green-status {
    background: rgba(86, 172, 52, 0.14);
    color: #56AC34;
    .el-icon-warning {
      color: #56AC34;
    }
  }
  .red-status {
    background: rgba(243, 95, 27, 0.14);
    color: #F46422;
    .el-icon-warning {
      color: #F46422;
    }
  }
}
</style>
<style lang="scss">
.supplier-configure {
  .table {
    .cell {
      .el-button + .el-button {
        margin-left: 24px;
      }
      .el-switch {
        width: 48px;
        line-height: 32px;
      }
      display: flex;
      align-items: center;
    }
    .btn-red {
      color: #F46422;
    }
  }
  .el-dialog__header {
    border-bottom:1px solid #eee;
  }
  .el-dialog {
    .el-dialog__body {
      padding-top: 28px;
    }
  }
  .el-dialog__footer {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
}
</style>